export function getDropdownItemListKey(
    index: number,
    heapIdentifier: string,
    path?: string | URL,
): string {
    const pathPart =
        path === undefined || path === '' ? '' : typeof path === 'string' ? path : path.href;
    return `${index}:${heapIdentifier}:${pathPart}`;
}
